"use strict";

document.addEventListener("DOMContentLoaded", function (event) {
    if(jQuery(".announcement-slider").hasClass('slick-initialized')) return;
  jQuery(".announcement-slider").slick({
    autoplay: true,
    autoplaySpeed: 0,
    speed: 15000,
    arrows: false,
    swipe: false,
    slidesToShow: 1,
    cssEase: "linear",
    pauseOnFocus: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          slidesToShow: 1,
        },
      },
    ],
  });
});
